// extracted by mini-css-extract-plugin
export var resetButton = "searchBox-module--resetButton--d5f09";
export var searchIcon = "searchBox-module--searchIcon--0f8e8";
export var searchInputStyles = "searchBox-module--searchInputStyles--6b0c5";
export var styledSearchBox = "searchBox-module--styledSearchBox--28a99";